// src/api/axiosInstance.js
import axios from "axios";
// import { toast } from "react-toastify";
import { getToken } from "../utils/auth";

// set this to your ngrok base (no trailing slash)
// const BASE = process.env.REACT_APP_API_URL;
// console.log(BASE);


const axiosInstance = axios.create({
  baseURL: "https://demo-grv-backend.vercel.app/api/v1",
  headers: {
    "Content-Type": "application/json",
    // "ngrok-skip-browser-warning": "true"
  },
});

// attach token
axiosInstance.interceptors.request.use((config) => {
  const token = getToken();
  // console.log("TOKEN SENT:", token);
  if (token) config.headers.Authorization = `Bearer ${token}`;
  // console.log("config", config.headers.Authorization);
  return config;
});


// global error toast
axiosInstance.interceptors.response.use(
  (res) => res,
  (err) => {
    const msg =
      err?.response?.data?.message ||
      err?.response?.data?.error ||
      err?.message ||
      "Something went wrong";
    // toast.error(msg);
    return Promise.reject(err);
  }
);

export default axiosInstance;
